import { Component, Input, OnInit } from '@angular/core';
import { SrsBallotReviewStage } from '../../models/sr/srs-ballot-review-stage';
import { StatusBadgeColourScheme } from '../../../../controls/status-badge/status-badge-constants';

@Component({
    selector: 'app-ballot-review-stage-badge',
    templateUrl: './ballot-review-stage-badge.component.html',
    styleUrl: './ballot-review-stage-badge.component.scss',
    standalone: false
})

export class BallotReviewStageBadgeComponent implements OnInit {

  @Input() reviewStageId?: SrsBallotReviewStage;
  @Input() reviewStageDisplayText?: string;
  badgeColourScheme: StatusBadgeColourScheme = StatusBadgeColourScheme.grey;


  ngOnInit(): void {
    this.badgeColourScheme = this.getBadgeColourScheme(this.reviewStageId);
  }

  getBadgeColourScheme(reviewStageId: number | undefined | null): StatusBadgeColourScheme {
    if(reviewStageId === undefined || reviewStageId === null) {
      return StatusBadgeColourScheme.grey;
    }

    switch(reviewStageId) {
      case SrsBallotReviewStage.ReadyForReviewSubmission:
        return StatusBadgeColourScheme.grey;
      case SrsBallotReviewStage.SrtReview:
        return StatusBadgeColourScheme.Green;
      case SrsBallotReviewStage.SdApproverReview:
        return StatusBadgeColourScheme.Red;
      case SrsBallotReviewStage.PgmReview:
        return StatusBadgeColourScheme.warningOrange;
      case SrsBallotReviewStage.RegulatorReview:
        return StatusBadgeColourScheme.Blue2;
      case SrsBallotReviewStage.SnzReview:
        return StatusBadgeColourScheme.grey;
      default:
        return StatusBadgeColourScheme.grey;
    }
  }
}
